module.exports = __webpack_public_path__ + "img/Google-play-logo.69459dee.png";